import axios from './axiosInstance';

export default {
  // Upload a new file
  uploadFile(file, projectId) {
    const formData = new FormData();
    formData.append('project_id', projectId);
    /*formData.append('stakeholder_id', stakeholderId);
    if (communicationId) {
      formData.append('communication_id', communicationId);
    }*/
    formData.append('file', file);

    return axios.post(`/files/upload?project_id=${projectId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Search files for a project
  searchFiles(projectId, query, page = 1, size = 10) {
    return axios.get(`/files/search/${projectId}`, {
      params: { query, page, size },
    });
  },

  // Get all files for a project
  getFilesByProjectId(projectId, page = 1, size = 10) {
    return axios.get(`/files`, {
      params: { project_id: projectId, page, size },
    });
  },

  deleteFile(fileId) {
    return axios.delete(`/files/${fileId}`);
  }
};
